import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import Grid from "@mui/material/Grid";
import {
  Box,
  Button,
  CardMedia,
  Chip,
  Divider,
  FormControl,
  IconButton,
  MenuItem,
  Select,
  Typography,
  Accordion,
  AccordionSummary,
  AccordionDetails,
  Tooltip,
  Dialog,
  DialogContent,
  DialogContentText,
  DialogActions,
  Stack,
  Pagination,
  InputLabel,
} from "@mui/material";
// Icon
import AddCircleOutlineOutlinedIcon from "@mui/icons-material/AddCircleOutlineOutlined";
import EditRoundedIcon from "@mui/icons-material/EditRounded";
import DeleteRoundedIcon from "@mui/icons-material/DeleteRounded";
import InfoIcon from "@mui/icons-material/Info";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import CallMadeIcon from "@mui/icons-material/CallMade";
// react-lazy-load-image
import { LazyLoadImage } from "react-lazy-load-image-component";
import "react-lazy-load-image-component/src/effects/blur.css";
import { PF } from "../../../../config";
import ReactPlayer from "react-player";
// Media Query
import { useTheme } from "@mui/material/styles";
import useMediaQuery from "@mui/material/useMediaQuery";

import SearchFilterBar from "../../../../components/adminPanel/shared/SearchFilterBar";
import PageHeader from "../../../../components/adminPanel/shared/PageHeader";
import SectionLabelChip from "../../../../components/adminPanel/shared/SectionLabelChip";
import EmptyStateAlert from "../../../../components/adminPanel/shared/EmptyStateAlert";
import { colors, radii, shadows, fonts } from "../../../../theme/designTokens";
import MedicineVideoDialog from "../dialog/MedicineVideoDialog";
import CustomVideoPlayer from "../../../../components/misc/CustomVideoPlayer";
import { ExpandMore, Info } from "@mui/icons-material";
import PriceInfoPanel from "./PriceInfoPanel";
import AddLangDialog from "../dialog/AddLangDialog";
// import { medData } from "../data/medData";
import AddMedicineDialog from "../dialog/AddMedicineDialog";
import {
  getCompanies,
  getDosages,
  getMedCategories,
  getMedicines,
  getSeoTags,
  removeSingleMedicine,
} from "../../../../reduxToolkit/features/adminPanel/medicine";
import { getSuppliers } from "../../../../reduxToolkit/features/adminPanel/supplier";
import { getNotification } from "../../../../reduxToolkit/features/adminPanel/notification";
import { formatDistance } from "date-fns";
import EditMedicineDialog from "../dialog/EditMedicineDialog";
import LoadingBox from "../../../../components/misc/Loading";
import { getExactTime } from "../../../../hooks/getCreatedData";
import { makeUrlFriendly } from "../../../../hooks/makeUrlFriendly";
import { buildFrontendUrl } from "../../../../hooks/langAlias";
import { formatMedicinePackSize } from "../../../../hooks/formatMedicinePackSize";

export default function ManageMedicine() {
  // Media Query
  const theme = useTheme();
  const smUp = useMediaQuery(theme.breakpoints.up("sm"));
  const mdUp = useMediaQuery(theme.breakpoints.up("md"));
  // use States
  const [loading, setLoading] = useState(false);
  const [searchBarLoading, setSearchBarLoading] = useState(false);
  const [lang, setLang] = useState("");
  const [langId, setLangId] = useState("");
  const [medList, setMedList] = useState([]);
  const [medListEn, setMedListEn] = useState([]);
  const [searchMedList, setSearchMedList] = useState([]);
  const [searchingMedList, setSearchingMedList] = useState([]);
  const [activeImg, setActiveImg] = useState();
  const [activeVid, setActiveVid] = useState();
  const [viewVidArr, setViewVidArr] = useState([]);
  const [dosageList, setDosageList] = useState([]);
  const [, setDosageListEn] = useState([]);

  const [sortBy, setSortBy] = useState(1);
  // Dialog
  const [addLangDlg, setAddLangDlg] = useState(false);
  const [mobileVideoDlg, setMobileVideoDlg] = useState(false);
  const [mobileVideoX, setMobileVideoX] = useState([]);
  const [addMedicineDlg, setAddMedicineDlg] = useState(false);
  const [deleteMedicineDlg, setDeleteMedicineDlg] = useState(false);
  const [deleteMedicineBuffer, setDeleteMedicineBuffer] = useState("");
  const [editMedicineDlg, setEditMedicineDlg] = useState(false);
  const [editMedicineBuffer, setEditMedicineBuffer] = useState("");

  // LocalData
  const localLangData = JSON.parse(localStorage.getItem("lang"));
  const localAdminData = JSON.parse(localStorage.getItem("adminLoginInfo"));
  // store
  const { langs, activeLang } = useSelector((state) => state.misc);
  const { medicines, categories, companies, medVariants, seoTags, dosages } =
    useSelector((state) => state.medicine);
  const { admins } = useSelector((state) => state.admin);

  // UseEffect
  // Set Language
  useEffect(() => {
    if (activeLang && activeLang.langCode) {
      setLang(activeLang.langCode);
      setLangId(activeLang._id);
    } else {
      if (localLangData) {
        setLang(localLangData.langCode);
        setLangId(localLangData._id);
      }
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [activeLang]);

  // Get medicines
  const dispatch = useDispatch();
  // useEffect(() => {
  //   lang !== "" && dispatch(getMedicines());
  // }, [lang]);

  useEffect(() => {
    if (!(medicines && medicines.length > 0)) dispatch(getMedicines());
    dispatch(getMedCategories());
    dispatch(getCompanies());
    dispatch(getSuppliers());
    dispatch(getSeoTags());
    dispatch(getDosages());
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  // set Dosage List
  useEffect(() => {
    if (lang !== "" && dosages && dosages.length > 0) {
      const D = dosages.find((d) => d.lang === lang);
      if (D && D.data) setDosageList(D.data);
      else setDosageList([]);
      const DEn = dosages.find((d) => d.lang === "en");
      if (DEn && DEn.data) setDosageListEn(DEn.data);
      else setDosageListEn([]);
    }
  }, [dosages, lang]);

  // set medData
  useEffect(() => {
    setLoading(true);
    if (lang !== "" && medicines && medicines.length > 0) {
      let M = medicines.find((m) => m.lang === lang);
      let MEn = medicines.find((men) => men.lang === "en");
      let searchArr = [];
      if (M && M.data) {
        let arr = [];
        let arrImg = [];
        let arrVid = [];
        let tempArr = [...M.data];
        tempArr.map((x, i) => {
          let obj = { ...x };
          // Setup Image
          if (obj.image && obj.image.length > 0) {
            const I = obj.image.find((i) => i.default === true);
            I ? arrImg.push(I) : arrImg.push("");
          } else arrImg.push("");
          // Setup Video
          if (obj.video && obj.video.length > 0) {
            const V = obj.video.find((i) => i.default === true);
            V ? arrVid.push(V) : arrVid.push("");
          } else arrVid.push("");
          // Setup Category & Sub Category
          let catsArr = [];
          let subCatsArr = [];
          obj.subCats.map((z, k) => {
            if (categories.length > 0) {
              const Cat = categories.find((c) => c.lang === lang);
              if (Cat) {
                Cat.data.map((y, j) => {
                  const Sc = y.subCatList.find((sc) =>
                    lang === "en"
                      ? sc.fixedSubCatId === z.subCatId
                      : sc.subCatDetectorId === z.subCatId
                  );
                  Sc && catsArr.push(y);
                  Sc && subCatsArr.push(Sc.subCatName);
                  return 0;
                });
              }
            }
            return 0;
          });
          var cA = [...catsArr];
          if (cA.length > 0) {
            const unique = [
              ...new Map(cA.map((item) => [item["fixedCatId"], item])).values(),
            ];
            obj.catsArr = unique;
          }

          obj.subCatsArr = subCatsArr;
          // Setup Company
          if (companies.length > 0) {
            const Comp = companies.find((c) => c.lang === lang);
            if (Comp) {
              const C = Comp.data.find((c) =>
                lang === "en"
                  ? c.fixedCompanyId === x.companyId
                  : c.companyDetectorId === x.companyId
              );
              if (C) obj.company = C;
            }
          }
          // Setup Variants
          let variantArr = [];
          if (medVariants.length > 0) {
            x.variants.forEach((y, j) => {
              let V = medVariants.find((v) => v.fixedVariantId === y.variantId);
              if (V) {
                let vArr = { ...V };
                variantArr.push(vArr);
              }
            });
          }
          // Setup Tags
          let tagsArr = [];
          if (seoTags.length > 0) {
            const STag = seoTags.find((st) => st.lang === lang);
            if (STag) {
              x.tags.forEach((y, j) => {
                const T = STag.data.find((t) =>
                  lang === "en"
                    ? t.fixedId === y.tagsId
                    : t.tagDetectorId === y.tagsId
                );
                T && tagsArr.push(T);
              });
            }
          }
          obj.tagsArr = tagsArr;
          obj.variantInfo = variantArr;

          // Setup Active Tab
          obj.activeAdditionalSectionTab = x.additionalSections[0];

          // search Name
          obj.searchName = x.genericBrand;
          if (admins.length > 0) {
            const { adminName } = admins.find((a) => a._id === x.creatorId) || {};
            if (adminName) obj.creatorName = adminName;
          }
          arr.push(obj);
          return 0;
        });
        setActiveImg(arrImg);
        setActiveVid(arrVid);
        searchArr = [...searchArr, ...arr];
        let searchEngVariants = [];
        if (MEn && MEn.data && lang !== "en") {
          // Search
          MEn.data.map((x, i) => {
            const M = arr.find(
              (m) => m.medicineDetectorId === x.fixedMedicineId
            );
            if (M) {
              const { searchName, ...others } = M;
              searchEngVariants.push({ searchName: x.genericBrand, ...others });
            }
            return 0;
          });
        }
        searchArr = [...searchArr, ...searchEngVariants];
        const unique = [
          ...new Map(searchArr.map((item) => [item["_id"], item])).values(),
        ];

        setSearchMedList(unique);
        setMedList(unique);
      } else {
        setMedList([]);
        setSearchMedList([]);
      }
      if (MEn && MEn.data) {
        let arr = [];
        MEn.data.map((x, i) => {
          let obj = { ...x };

          // Setup Category & Sub Category
          let catsArr = [];
          let subCatsArr = [];
          obj.subCats.map((z, k) => {
            if (categories.length > 0) {
              const Cat = categories.find((c) => c.lang === "en");
              if (Cat) {
                Cat.data.map((y, j) => {
                  const Sc = y.subCatList.find(
                    (sc) => sc.fixedSubCatId === z.subCatId
                  );
                  Sc && catsArr.push(y);
                  Sc && subCatsArr.push(Sc.subCatName);
                  return 0;
                });
              }
            }
            return 0;
          });
          var cA = [...catsArr];
          if (cA.length > 0) {
            const unique = [
              ...new Map(cA.map((item) => [item["fixedCatId"], item])).values(),
            ];
            obj.catsArr = unique;
          }

          obj.subCatsArr = subCatsArr;
          // Setup Company
          if (companies.length > 0) {
            const Comp = companies.find((c) => c.lang === "en");
            if (Comp) {
              const C = Comp.data.find((c) => c.fixedCompanyId === x.companyId);
              if (C) obj.company = C;
            }
          }
          // Setup Variants
          let variantArr = [];
          if (medVariants.length > 0) {
            x.variants.forEach((y, j) => {
              let V = medVariants.find((v) => v.fixedVariantId === y.variantId);
              if (V) {
                let vArr = { ...V };
                variantArr.push(vArr);
              }
            });
          }
          // Setup Tags
          let tagsArr = [];
          if (seoTags.length > 0) {
            const STag = seoTags.find((st) => st.lang === "en");
            if (STag) {
              x.tags.forEach((y, j) => {
                const T = STag.data.find((t) => t.fixedId === y.tagsId);
                T && tagsArr.push(T);
              });
            }
          }
          obj.tagsArr = tagsArr;
          obj.variantInfo = variantArr;
          arr.push(obj);
          return 0;
        });
        // setActiveImgEn(arrImg);
        // setActiveVid(arrVid);
        setTotalPage(M && M.data ? Math.ceil(M.data.length / 12) : 0);

        setMedListEn(arr);
      } else {
        setMedListEn([]);
        setTotalPage(0);
      }
      setTimeout(() => {
        setLoading(false);
      }, 2000);
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [
    categories,
    // companies,
    lang,
    medicines,
    // medVariants,
    // suppliers,
    // seoTags,
    // admins,
  ]);

  // Functions
  const handleChangeImage = (i, y) => {
    let arr = [...activeImg];
    arr[i] = y;
    setActiveImg(arr);
  };

  const handleChangeVid = (i, y) => {
    let arr = [...activeVid];
    arr[i] = y;
    setActiveVid(arr);
  };

  const handleChangeLang = (e) => {
    // Pagination Stuff
    setSearchingMedList([]);
    setProductViewStart(0);
    setPageNum(1);
    setPaginateLoading(true);

    setSearchBarLoading(true);
    const L = langs.find((l) => l.langCode === e.target.value);
    if (L) setLangId(L._id);
    setLang(e.target.value);
    setTimeout(() => {
      setSearchBarLoading(false);
      setSearchingMedList([]);
      setPaginateLoading(false);
    }, 100);
  };

  const handleMobileVideo = (vid) => {
    setMobileVideoDlg(true);
    setMobileVideoX(vid);
  };

  // Handle Non Mobile Video
  const handleNonMobileVideo = (id) => {
    let arr = [...viewVidArr];
    if (arr.includes(id)) {
      const index = arr.indexOf(id);
      arr.splice(index, 1);
    } else arr.push(id);
    setViewVidArr(arr);
  };

  // handle Medicine Delete
  const handleMedDelete = (id) => {
    setDeleteMedicineBuffer(id);
    setDeleteMedicineDlg(true);
  };

  // handle Confirm Delete
  const handleConfirmDelete = () => {
    dispatch(
      removeSingleMedicine({
        id: deleteMedicineBuffer,
        creatorId: localAdminData._id,
        lang,
      })
    );
    setDeleteMedicineDlg(false);
    setTimeout(() => {
      dispatch(getMedicines());
      dispatch(getNotification());
    }, 1000);
  };

  // handle Medicine Edit
  const handleMedEdit = (id) => {
    setEditMedicineDlg(true);
    const M = medList.find((m) => m._id === id);
    M && setEditMedicineBuffer(M);
  };

  // Handle Search
  const handleSearch = (e, newValue) => {
    let arr = [...newValue];
    const unique = [
      ...new Map(arr.map((item) => [item["_id"], item])).values(),
    ];
    let arrImg = [];
    let arrVid = [];
    (unique.length > 0 ? unique : searchMedList).forEach((x) => {
      let obj = { ...x };
      // Setup Image
      if (obj.image && obj.image.length > 0) {
        const I = obj.image.find((i) => i.default === true);
        I ? arrImg.push(I) : arrImg.push("");
      } else arrImg.push("");
      // Setup Video
      if (obj.video && obj.video.length > 0) {
        const V = obj.video.find((i) => i.default === true);
        V ? arrVid.push(V) : arrVid.push("");
      } else arrVid.push("");
    });
    setActiveImg(arrImg);
    setActiveVid(arrVid);

    setSearchingMedList([...unique]);
  };

  // Handle Active Tab
  const handleSelectTab = (x, id) => {
    let arr = [...medList];
    const index = arr.indexOf(arr.find((a) => a.fixedMedicineId === id));
    arr[index].activeAdditionalSectionTab = x;
    setMedList(arr);
  };

  // get MEd Name En
  const getMedNameEn = (id) => {
    const M = medListEn.find((m) => m.fixedMedicineId === id);
    if (M) return M.genericBrand;
  };

  // get MEd Generic Name En
  const getMedGenericNameEn = (id) => {
    const M = medListEn.find((m) => m.fixedMedicineId === id);
    if (M) return M.generic;
  };

  // Fixed date
  const [showDate, setShowDate] = useState([]);

  const handleShowDate = (date) => {
    let arr = [...showDate];
    if (arr.includes(date)) {
      arr = arr.filter((a) => a !== date);
    } else {
      arr.push(date);
    }
    setShowDate(arr);
  };

  const getDosageName = (dosageId) => {
    let dosageName = "";
    const D = dosageList.find(
      (d) => (lang !== "en" ? d.dosageDetectorId : d.fixedDosageId) === dosageId
    );
    if (D && D.dosageName) dosageName = D.dosageName;
    return dosageName;
  };

  // ! translate
  const [siteLang, setSiteLang] = useState("en");
  const [langSettings1, setLangSettings1] = useState([]);
  const [langSettings2, setLangSettings2] = useState([]);
  const [langSettings3, setLangSettings3] = useState([]);
  const [langSettings4, setLangSettings4] = useState([]);
  const [langSettings5, setLangSettings5] = useState([]);
  const [langSettings6, setLangSettings6] = useState([]);
  const [langSettings7, setLangSettings7] = useState([]);
  const [langSettings8, setLangSettings8] = useState([]);
  const title1 = "Manage Medicine";
  const title2 = "Misc Words";
  const title3 = "Identification";
  const title4 = "Variation";
  const title5 = "Price Info";
  const title6 = "SEO";
  const title7 = "Actions";
  const title8 = "Additional Section";

  useEffect(() => {
    if (langs && langs.length > 0 && siteLang !== "") {
      const L = langs.find((l) => l.langCode === siteLang);
      let arr = [];
      if (L && L.langSettings && L.langSettings.length > 0)
        arr = L.langSettings;
      else {
        const LEn = langs.find((l) => l.langCode === "en");
        if (LEn && LEn.langSettings && LEn.langSettings.length > 0)
          arr = LEn.langSettings;
      }
      const A = arr.find((l) => l._title === title1);
      if (A) setLangSettings1(A.data);
      const B = arr.find((l) => l._title === title2);
      if (B) setLangSettings2(B.data);
      const C = arr.find((l) => l._title === title3);
      if (C) setLangSettings3(C.data);
      const D = arr.find((l) => l._title === title4);
      if (D) setLangSettings4(D.data);
      const E = arr.find((l) => l._title === title5);
      if (E) setLangSettings5(E.data);
      const F = arr.find((l) => l._title === title6);
      if (F) setLangSettings6(F.data);
      const G = arr.find((l) => l._title === title7);
      if (G) setLangSettings7(G.data);
      const H = arr.find((l) => l._title === title8);
      if (H) setLangSettings8(H.data);
    }
  }, [siteLang, langs]);

  const translate1 = (String) => translation(String, title1, 1);
  const translate2 = (String) => translation(String, title2, 2);
  const translate3 = (String) => translation(String, title3, 3);
  const translate4 = (String) => translation(String, title4, 4);
  const translate5 = (String) => translation(String, title5, 5);
  const translate6 = (String) => translation(String, title6, 6);
  const translate7 = (String) => translation(String, title7, 7);
  const translate8 = (String) => translation(String, title8, 8);

  const translation = (String, title, index) => {
    let translation = "";
    let settings = [];
    if (index === 1) {
      settings = langSettings1;
    } else if (index === 2) {
      settings = langSettings2;
    } else if (index === 3) {
      settings = langSettings3;
    } else if (index === 4) {
      settings = langSettings4;
    } else if (index === 5) {
      settings = langSettings5;
    } else if (index === 6) {
      settings = langSettings6;
    } else if (index === 7) {
      settings = langSettings7;
    } else if (index === 8) {
      settings = langSettings8;
    }
    const T = settings.find((ls) => ls.title === String);
    if (T && T.value) translation = T.value;
    else {
      let arr = [];
      if (langs && langs.length > 0 && siteLang !== "") {
        const LEn = langs.find((l) => l.langCode === "en");
        if (LEn && LEn.settings && LEn.settings.length > 0) arr = LEn.settings;
        const S = arr.find((l) => l._title === title);
        if (S) {
          const T = S.data.find((ls) => ls.title === String);
          if (T && T.value) translation = T.value;
        }
      }
    }
    return translation;
  };

  useEffect(() => {
    if (activeLang && activeLang.langCode) {
      setSiteLang(activeLang.langCode);
      setSearchingMedList([]);
      setProductViewStart(0);
      setPageNum(1);
    } else {
      if (localLangData) {
        setSiteLang(localLangData.langCode);
        setPageNum(1);
        setSearchingMedList([]);
        setProductViewStart(0);
      }
    }
    setPaginateLoading(true);
    setTimeout(() => {
      setPaginateLoading(false);
    }, 100);
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [activeLang]);
  // ! translate

  // Pagination
  const [totalPage, setTotalPage] = useState(0);
  const [pageNum, setPageNum] = useState(1);
  const [productViewStart, setProductViewStart] = useState(0);
  const [paginateLoading, setPaginateLoading] = useState(false);

  const handlePageChange = (event, value) => {
    setPageNum(value);
    // setTimeout(() => {
    // scroll();
    // }, 250);
  };

  useEffect(() => {
    if (pageNum > 1) setProductViewStart((pageNum - 1) * 12);
    else setProductViewStart(0);
  }, [pageNum]);

  // handle Sort
  useEffect(() => {
    let sortedArr = [];
    if (sortBy === 1) {
      sortedArr = [...medList].sort((a, b) =>
        new Date(a.createdAt).getTime() > new Date(b.createdAt).getTime()
          ? -1
          : 1
      );
    } else {
      sortedArr = [...searchMedList].sort((a, b) =>
        a.genericBrand.toLowerCase().replace(/\s/g, "") >
        b.genericBrand.toLowerCase().replace(/\s/g, "")
          ? 1
          : -1
      );
    }
    // setMedList(sortedArr)
    setSearchMedList(sortedArr);
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [sortBy, medList]);

  //! Translate
  // Store
  const { langArrFromClientSide } = useSelector((state) => state.misc);
  const translate0 = (String) => {
    let translation = "";
    if (langArrFromClientSide && langArrFromClientSide.length > 0) {
      const T = langArrFromClientSide.find((l) => l.title === String);
      if (T && T.value) {
        let obj = { ...T };
        if (T.value === "") obj.value = T.title;
        translation = T.value;
      } else if (T === undefined) translation = String;
    }
    return translation;
  };
  //! Translate

  return (
    <Box sx={{ maxWidth: !smUp ? 250 : "100%" }}>
      {langs.length > 0 && (
        <>
          <PageHeader
            title={
              <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                {translate1("Medicines")}
                <Chip
                  label={medList.length}
                  size="small"
                  sx={{
                    bgcolor: colors.primary,
                    color: colors.white,
                    fontWeight: 700,
                  }}
                />
              </Box>
            }
            action={
              <Box sx={{ display: "flex", alignItems: "center", gap: 1, flexWrap: "wrap" }}>
                <Tooltip title="Add Language" arrow placement="top">
                  <IconButton size="small" onClick={() => setAddLangDlg(true)}>
                    <AddCircleOutlineOutlinedIcon color="info" />
                  </IconButton>
                </Tooltip>
                <AddLangDialog
                  addLangDlg={addLangDlg}
                  setAddLangDlg={setAddLangDlg}
                  setLang={setLang}
                />
                <FormControl size="small" sx={{ minWidth: 130 }}>
                  <Select value={lang} onChange={handleChangeLang}>
                    {langs.map((x, i) => (
                      <MenuItem key={i} value={x.langCode} dense>
                        <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                          <img
                            alt={x.langCode}
                            src={`https://flagcdn.com/w20/${
                              x.langCode === "en" ? "gb" : x.langCode
                            }.png`}
                            style={{ borderRadius: 2 }}
                          />
                          <Typography sx={{ fontSize: 14 }}>{x.langName}</Typography>
                        </Box>
                      </MenuItem>
                    ))}
                  </Select>
                </FormControl>
                <Button
                  variant="contained"
                  size="small"
                  color="error"
                  onClick={() => setAddMedicineDlg(true)}
                >
                  {translate1("Add Medicine")}
                </Button>
                {addMedicineDlg && (
                  <AddMedicineDialog
                    addMedicineDlg={addMedicineDlg}
                    setAddMedicineDlg={setAddMedicineDlg}
                    lang={lang || "en"}
                    langId={langId}
                    medListEn={medListEn || []}
                  />
                )}
              </Box>
            }
          />
          {/* Search */}
          <Box sx={{ mb: 2 }}>
            {!searchBarLoading && (
              <SearchFilterBar
                multiple
                options={searchMedList}
                onChange={(e, newValue) => handleSearch(e, newValue)}
                optionsLimit={50}
                label={translate1("Search") + "..."}
                getOptionLabel={(option) =>
                  `${option.genericBrand} (${option.generic}) ${
                    lang !== "en"
                      ? " - " +
                        getMedNameEn(option.medicineDetectorId) +
                        " (" +
                        getMedGenericNameEn(option.medicineDetectorId) +
                        ")"
                      : ""
                  }`
                }
                renderOption={(props, option) => (
                  <Box
                    component="li"
                    sx={{ "& > img": { mr: 2, flexShrink: 0 } }}
                    {...props}
                  >
                    <img
                      loading="lazy"
                      width="20"
                      src={
                        option.image.length > 0
                          ? option.image
                              .find((i) => i.default)
                              .src.includes("http")
                            ? option.image.find((i) => i.default).src
                            : PF +
                              "adminPanel/medicines/img/" +
                              option.image.find((i) => i.default).src
                          : PF + "adminPanel/medicines/no-medicine-image.jpg"
                      }
                      alt="admins"
                    />
                    {option.genericBrand} {" (" + option.generic + ") "}
                    {lang !== "en"
                      ? " - " + getMedNameEn(option.medicineDetectorId)
                      : ""}
                    {lang !== "en"
                      ? " (" +
                        getMedGenericNameEn(option.medicineDetectorId) +
                        ")"
                      : ""}
                  </Box>
                )}
              />
            )}
          </Box>
          {/* Sort */}
          <Box sx={{ display: "flex", justifyContent: "flex-end", mb: 2 }}>
            <FormControl size="small" sx={{ minWidth: 180 }}>
              <InputLabel id="demo-simple-select-label">
                {translate0("Sort")}
              </InputLabel>
              <Select
                labelId="demo-simple-select-label"
                id="demo-simple-select"
                value={sortBy}
                label={translate0("Sort")}
                onChange={(e) => setSortBy(e.target.value)}
              >
                <MenuItem value={1}>{translate0("Creation")}</MenuItem>
                <MenuItem value={2}>{translate0("Generic Brand")}</MenuItem>
              </Select>
            </FormControl>
          </Box>
          {!paginateLoading &&
            totalPage >= 1 &&
            // !medList.includes("null") &&
            !searchingMedList.length > 0 &&
            medList.length > 0 && (
              <Grid
                item
                xs={12}
                sx={{
                  display: "flex",
                  justifyContent: "center",
                  width: "100%",
                  mt: 2,
                }}
              >
                <Stack spacing={2}>
                  <Pagination
                    count={totalPage}
                    color="primary"
                    onChange={handlePageChange}
                    size={smUp ? "medium" : "small"}
                    hideNextButton={smUp ? false : true}
                    hidePrevButton={smUp ? false : true}
                  />
                </Stack>
              </Grid>
            )}
          <Box
            sx={{
              maxHeight: { xs: "60vh", sm: "53vh" },
              overflowY: "auto",
              overflowX: "hidden",
              mt: 3,
              bgcolor: colors.paperTint,
              borderRadius: radii.lg,
              p: { xs: 1, sm: 1.5 },
            }}
          >
            {loading ? (
              <LoadingBox w={"100%"} h={300} />
            ) : medList.length < 1 ? (
              <EmptyStateAlert message={translate2("No Medicine Available")} />
            ) : (
              (searchingMedList.length > 0
                ? searchingMedList
                : searchMedList.slice(productViewStart, productViewStart + 12)
              ).map((x, i) => (
                <Box
                  key={i}
                  sx={{
                    bgcolor: colors.white,
                    border: `1px solid ${colors.line}`,
                    borderRadius: radii.lg,
                    boxShadow: shadows.card,
                    p: { xs: 2, sm: 2.5 },
                    mb: 2.5,
                  }}
                >
                  {/* Header: thumbnail + identity + actions */}
                  <Grid container spacing={2}>
                    <Grid item xs="auto">
                      <Box
                        sx={{
                          width: 84,
                          height: 84,
                          borderRadius: radii.md,
                          border: `1px solid ${colors.line}`,
                          bgcolor: colors.paperTint,
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                          overflow: "hidden",
                          flexShrink: 0,
                        }}
                      >
                        <LazyLoadImage
                          effect="blur"
                          src={
                            x.image && x.image.length > 0
                              ? x.image[0]?.src !== "" &&
                                PF +
                                  "adminPanel/medicines/img/" +
                                  x.image[0].src
                              : PF + "adminPanel/medicines/blank.jpg"
                          }
                          alt={
                            x.image && x.image.length > 0
                              ? x.image[0]?.alt !== "" && x.image[0]?.alt
                              : "no-image"
                          }
                          title={
                            x.image && x.image.length > 0
                              ? x.image[0]?.alt !== "" && x.image[0]?.alt
                              : "no-image"
                          }
                          style={{
                            width: "100%",
                            height: "100%",
                            objectFit: "cover",
                          }}
                        />
                      </Box>
                      {x.image.length > 1 && (
                        <Box
                          sx={{
                            display: "flex",
                            gap: 0.5,
                            mt: 0.75,
                            flexWrap: "wrap",
                            maxWidth: 84,
                          }}
                        >
                          {x.image.map(
                            (y, j) =>
                              j < 4 && (
                                <Box
                                  key={j}
                                  component="img"
                                  src={PF + "adminPanel/medicines/img/" + y.src}
                                  alt={y.alt}
                                  title={y.alt}
                                  onClick={() => handleChangeImage(i, y)}
                                  sx={{
                                    width: 18,
                                    height: 18,
                                    objectFit: "cover",
                                    borderRadius: "4px",
                                    cursor: "pointer",
                                    border: `1px solid ${colors.line}`,
                                  }}
                                />
                              )
                          )}
                        </Box>
                      )}
                    </Grid>
                    <Grid item xs>
                      <Box
                        sx={{
                          display: "flex",
                          alignItems: "center",
                          gap: 1,
                          flexWrap: "wrap",
                        }}
                      >
                        <Typography
                          sx={{
                            fontFamily: fonts.display,
                            fontWeight: 800,
                            fontSize: "1.05rem",
                            color: colors.ink,
                          }}
                        >
                          {x.genericBrand.toUpperCase()}
                        </Typography>
                        {x.prescribed && (
                          <Chip label="Rx" size="small" color="error" />
                        )}
                        <Tooltip title="View on site" arrow placement="top">
                          <IconButton
                            size="small"
                            onClick={() =>
                              window.open(
                                (window.location.hostname === "localhost"
                                  ? "http://localhost:3000"
                                  : "https://" + window.location.hostname) +
                                  buildFrontendUrl(
                                    lang,
                                    "/our-medicines/" +
                                      makeUrlFriendly(
                                        lang !== "en"
                                          ? getMedNameEn(x.medicineDetectorId)
                                          : x.genericBrand
                                      )
                                  ),
                                "_blank"
                              )
                            }
                          >
                            <CallMadeIcon fontSize="small" color="info" />
                          </IconButton>
                        </Tooltip>
                        {lang !== "en" && (
                          <Tooltip
                            arrow
                            title={`English Variant: ${getMedNameEn(
                              x.medicineDetectorId
                            )}`}
                            placement="top"
                          >
                            <IconButton size="small">
                              <Info color="info" fontSize="small" />
                            </IconButton>
                          </Tooltip>
                        )}
                      </Box>
                      <Typography sx={{ fontSize: 13.5, color: colors.ink3, mt: 0.25 }}>
                        {translate3("Generic")}: {x.generic.toUpperCase()}
                      </Typography>
                      <Box sx={{ display: "flex", flexWrap: "wrap", gap: 0.75, mt: 1 }}>
                        {x.catsArr &&
                          x.catsArr.length > 0 &&
                          x.catsArr.map(
                            (y, j) =>
                              y.catName && (
                                <Chip
                                  key={j}
                                  label={y.catName.toUpperCase()}
                                  size="small"
                                  sx={{ bgcolor: colors.primaryLight, color: colors.primary, fontWeight: 600 }}
                                />
                              )
                          )}
                        {x.subCatsArr &&
                          x.subCatsArr.length > 0 &&
                          x.subCatsArr.map((y, j) => (
                            <Chip
                              key={j}
                              label={y.toUpperCase()}
                              size="small"
                              variant="outlined"
                            />
                          ))}
                        <Chip
                          label={
                            x.stock > 0
                              ? translate4("Available") || "Available"
                              : translate4("Out Of Stock") || "Out Of Stock"
                          }
                          size="small"
                          color={x.stock > 0 ? "success" : "error"}
                          variant="outlined"
                        />
                      </Box>
                    </Grid>
                    <Grid item xs="auto">
                      <Box sx={{ display: "flex", gap: 0.5 }}>
                        <IconButton onClick={() => handleMedEdit(x._id)}>
                          <EditRoundedIcon color="primary" />
                        </IconButton>
                        <IconButton onClick={() => handleMedDelete(x._id)}>
                          <DeleteRoundedIcon color="error" />
                        </IconButton>
                      </Box>
                    </Grid>
                  </Grid>

                  <Divider sx={{ my: 2 }} />

                  {/* Key facts */}
                  <Grid container spacing={2}>
                    <Grid item xs={6} sm={3}>
                      <Typography sx={{ fontSize: 11.5, fontWeight: 700, color: colors.ink3, textTransform: "uppercase" }}>
                        {translate3("Local Company")}
                      </Typography>
                      <Box sx={{ display: "flex", alignItems: "center", gap: 0.75, mt: 0.25 }}>
                        <Typography sx={{ fontSize: 13.5, fontWeight: 600, color: colors.ink }}>
                          {x.company && x.company.companyName.toUpperCase()}
                        </Typography>
                        {x.company && (
                          <img
                            src={PF + "/adminPanel/companies/" + x.company.companyLogo}
                            alt={x.company && x.company.companyName}
                            style={{ height: "16px", objectFit: "cover", borderRadius: "4px" }}
                          />
                        )}
                      </Box>
                    </Grid>
                    <Grid item xs={6} sm={3}>
                      <Typography sx={{ fontSize: 11.5, fontWeight: 700, color: colors.ink3, textTransform: "uppercase" }}>
                        {translate3("Originator")}
                      </Typography>
                      <Typography sx={{ fontSize: 13.5, fontWeight: 600, color: colors.ink, mt: 0.25 }}>
                        {x.originator.toUpperCase()}
                      </Typography>
                    </Grid>
                    <Grid item xs={6} sm={3}>
                      <Typography sx={{ fontSize: 11.5, fontWeight: 700, color: colors.ink3, textTransform: "uppercase" }}>
                        {translate4("Dosage Form")}
                      </Typography>
                      <Typography sx={{ fontSize: 13.5, fontWeight: 600, color: colors.ink, mt: 0.25 }}>
                        {x.variantInfo &&
                          x.variantInfo.length > 0 &&
                          x.variantInfo.map(
                            (y, j) =>
                              getDosageName(y.dosageForm).toUpperCase() +
                              (x.variantInfo.length > 1 &&
                              j < x.variantInfo.length - 1
                                ? ", "
                                : "")
                          )}
                      </Typography>
                      <Typography sx={{ fontSize: 12, color: colors.ink3, mt: 0.25 }}>
                        {x.variantInfo &&
                          x.variantInfo.length > 0 &&
                          x.variantInfo.map(
                            (y, j) =>
                              y.strength &&
                              y.strength.toUpperCase() +
                                (x.variantInfo.length > 1 &&
                                j < x.variantInfo.length - 1
                                  ? ", "
                                  : "")
                          )}
                        {" · "}
                        {x.variantInfo &&
                          x.variantInfo.length > 0 &&
                          x.variantInfo.map(
                            (y, j) =>
                              y.packTypes &&
                              formatMedicinePackSize(y.packTypes) +
                                (x.variantInfo.length > 1 &&
                                j < x.variantInfo.length - 1
                                  ? ", "
                                  : "")
                          )}
                      </Typography>
                    </Grid>
                  </Grid>

                  {/* Price Info */}
                  {x.variantInfo && x.variantInfo.length > 0 && (
                    <PriceInfoPanel data={x.variantInfo} lang={lang} />
                  )}

                  {/* Video Section */}
                  {x.video && x.video.length > 0 && (
                  <Box sx={{ mt: 2 }}>
                    {!smUp ? (
                      //  Mobile
                      <Button
                        variant="outlined"
                        size="small"
                        color="secondary"
                        onClick={() => handleMobileVideo(x)}
                      >
                        {translate1("Video")}
                      </Button>
                    ) : (
                      // Pc
                      <Accordion
                        disableGutters
                        expanded={viewVidArr.includes(x._id)}
                        onChange={() => handleNonMobileVideo(x._id)}
                        sx={{ boxShadow: "none", border: `1px solid ${colors.line}`, borderRadius: radii.md, "&:before": { display: "none" } }}
                      >
                        <AccordionSummary expandIcon={<ExpandMore />}>
                          <SectionLabelChip label={translate1("Video")} />
                        </AccordionSummary>
                        <AccordionDetails>
                          <Grid container spacing={0} flexDirection="column">
                            {activeVid[i] && activeVid[i] !== "" && (
                              <Grid item sx={{ mb: 1, width: "100%", maxWidth: 360 }}>
                                <CustomVideoPlayer
                                  url={
                                    activeVid[i].externalLink
                                      ? activeVid[i].src
                                      : PF +
                                        "adminPanel/medicines/vid/" +
                                        activeVid[i].src
                                  }
                                  height={!mdUp ? 190 : 220}
                                />
                              </Grid>
                            )}
                            <Grid item>
                              <Grid container spacing={1}>
                                {x.video &&
                                  x.video.map((y, j) => (
                                    <Grid item key={j}>
                                      <>
                                        {j < 4 && (
                                          <>
                                            {y.externalLink ? (
                                              <ReactPlayer
                                                url={y.src}
                                                controls
                                                muted
                                                height="40px"
                                                width={!mdUp ? "40px" : "50px"}
                                                onPlay={() =>
                                                  handleChangeVid(i, y)
                                                }
                                              />
                                            ) : (
                                              <CardMedia
                                                component="video"
                                                sx={{
                                                  height: "40px",
                                                  width: !mdUp ? "40px" : "80px",
                                                }}
                                                image={
                                                  PF +
                                                  "adminPanel/medicines/vid/" +
                                                  y.src
                                                }
                                                // controls
                                                muted
                                                onClick={() =>
                                                  handleChangeVid(i, y)
                                                }
                                              />
                                            )}{" "}
                                          </>
                                        )}
                                      </>
                                    </Grid>
                                  ))}
                              </Grid>
                            </Grid>
                          </Grid>
                        </AccordionDetails>
                      </Accordion>
                    )}
                  </Box>
                  )}

                  {/* SEO Section */}
                  <Accordion disableGutters sx={{ mt: 2, boxShadow: "none", border: `1px solid ${colors.line}`, borderRadius: radii.md, "&:before": { display: "none" } }}>
                    <AccordionSummary expandIcon={<ExpandMore />}>
                      <SectionLabelChip label={translate2("SEO")} />
                    </AccordionSummary>
                    <AccordionDetails>
                      <Grid container spacing={1.5}>
                        <Grid item xs={12} sm={4}>
                          <Typography sx={{ fontSize: 11.5, fontWeight: 700, color: colors.ink3, textTransform: "uppercase" }}>
                            {translate6("Meta Keyword")}
                          </Typography>
                          <Typography sx={{ fontSize: 12.5, color: colors.ink2 }}>
                            {x.metaKeyword && x.metaKeyword}
                          </Typography>
                        </Grid>
                        <Grid item xs={12} sm={4}>
                          <Typography sx={{ fontSize: 11.5, fontWeight: 700, color: colors.ink3, textTransform: "uppercase" }}>
                            {translate6("Meta Title")}
                          </Typography>
                          <Typography sx={{ fontSize: 12.5, color: colors.ink2 }}>
                            {x.metaTitle && x.metaTitle}
                          </Typography>
                        </Grid>
                        <Grid item xs={12} sm={4}>
                          <Typography sx={{ fontSize: 11.5, fontWeight: 700, color: colors.ink3, textTransform: "uppercase" }}>
                            {translate6("Meta Description")}
                          </Typography>
                          <Typography sx={{ fontSize: 12.5, color: colors.ink2 }}>
                            {x.metaDesc &&
                              x.metaDesc.replace(
                                "medicineforworld@gmail.com",
                                "info@elifesavingmedicine.com"
                              )}
                          </Typography>
                        </Grid>
                        <Grid item xs={12}>
                          <Typography sx={{ fontSize: 11.5, fontWeight: 700, color: colors.ink3, textTransform: "uppercase", mb: 0.5 }}>
                            {translate6("Tags")}
                          </Typography>
                          <Box sx={{ display: "flex", flexWrap: "wrap", gap: 0.75 }}>
                            {x.tagsArr &&
                              x.tagsArr.map((y, j) => (
                                <Tooltip key={j} title={y.tagDetails} arrow placement="top">
                                  <Chip size="small" color={y.severity} label={y.tagName} />
                                </Tooltip>
                              ))}
                          </Box>
                        </Grid>
                      </Grid>
                    </AccordionDetails>
                  </Accordion>

                  {/* Additional Section */}
                  <Accordion disableGutters sx={{ mt: 2, boxShadow: "none", border: `1px solid ${colors.line}`, borderRadius: radii.md, "&:before": { display: "none" } }}>
                    <AccordionSummary expandIcon={<ExpandMore />}>
                      <SectionLabelChip label={translate2("Additional Section")} />
                    </AccordionSummary>
                    <AccordionDetails>
                    <Grid container spacing={1}>
                      {x.additionalSections.map((y, j) => (
                        <Grid item sx={{ minWidth: !smUp && "100%" }} key={j}>
                          <Button
                            variant={
                              x.activeAdditionalSectionTab.sectionName ===
                              y.sectionName
                                ? "contained"
                                : "outlined"
                            }
                            color="primary"
                            size="small"
                            onClick={() =>
                              handleSelectTab(y, x.fixedMedicineId)
                            }
                          >
                            {translate8(y.sectionName) !== ""
                              ? translate8(y.sectionName)
                              : y.sectionName}
                          </Button>
                        </Grid>
                      ))}

                      <Grid item xs={12}>
                        <Typography variant="h5" color="primary">
                          {translate8(
                            x.activeAdditionalSectionTab.sectionName
                          ) !== ""
                            ? translate8(
                                x.activeAdditionalSectionTab.sectionName
                              )
                            : x.activeAdditionalSectionTab.sectionName}
                        </Typography>
                      </Grid>
                      <Grid item xs={12}>
                        <Divider />
                      </Grid>
                      <Grid item xs={12} sx={{ pb: 2 }}>
                        <div
                          dangerouslySetInnerHTML={{
                            __html: `${x.activeAdditionalSectionTab.content}`,
                          }}
                        ></div>
                        <Accordion sx={{ maxWidth: "90vw" }}>
                          <AccordionSummary
                            expandIcon={<ExpandMoreIcon />}
                            aria-controls="panel1a-content"
                            id="panel1a-header"
                          >
                            <Typography>Source Code</Typography>
                          </AccordionSummary>
                          <AccordionDetails>
                            <Typography>
                              {x.activeAdditionalSectionTab.content}
                            </Typography>
                          </AccordionDetails>
                        </Accordion>
                      </Grid>
                    </Grid>
                    </AccordionDetails>
                  </Accordion>

                  {/* Meta footer */}
                  {(x.creatorName || x.createdAt || x.updatedAt) && (
                    <>
                      <Divider sx={{ my: 2 }} />
                      <Box sx={{ display: "flex", flexWrap: "wrap", gap: 2 }}>
                        {x.creatorName && (
                          <Typography sx={{ fontSize: 12, color: colors.ink3 }}>
                            {translate2("Created By")}:{" "}
                            <Typography component="span" sx={{ fontSize: 12, fontWeight: 600, color: colors.ink2 }}>
                              {x.creatorName.toUpperCase()}
                            </Typography>
                          </Typography>
                        )}
                        {x.createdAt && (
                          <Typography sx={{ fontSize: 12, color: colors.ink3 }}>
                            {translate7("Created")}:{" "}
                            <Typography component="span" sx={{ fontSize: 12, fontWeight: 600, color: colors.primary }}>
                              {formatDistance(new Date(x.createdAt), new Date(), { addSuffix: true })}
                            </Typography>
                            <Tooltip arrow placement="top" title={getExactTime(x.createdAt)}>
                              <IconButton size="small" onClick={() => handleShowDate(x.createdAt)}>
                                <InfoIcon color="info" sx={{ fontSize: 14 }} />
                              </IconButton>
                            </Tooltip>
                            {showDate.includes(x.createdAt) && (
                              <Typography component="span" sx={{ fontSize: 11, color: colors.ink3, display: "block" }}>
                                {getExactTime(x.createdAt)}
                              </Typography>
                            )}
                          </Typography>
                        )}
                        {x.updatedAt && (
                          <Typography sx={{ fontSize: 12, color: colors.ink3 }}>
                            {translate2("Updated")}:{" "}
                            <Typography component="span" sx={{ fontSize: 12, fontWeight: 600, color: colors.ink2 }}>
                              {formatDistance(new Date(x.updatedAt), new Date(), { addSuffix: true })}
                            </Typography>
                            <Tooltip arrow placement="top" title={getExactTime(x.updatedAt)}>
                              <IconButton size="small" onClick={() => handleShowDate(x.updatedAt)}>
                                <InfoIcon color="info" sx={{ fontSize: 14 }} />
                              </IconButton>
                            </Tooltip>
                            {showDate.includes(x.updatedAt) && (
                              <Typography component="span" sx={{ fontSize: 11, color: colors.ink3, display: "block" }}>
                                {getExactTime(x.updatedAt)}
                              </Typography>
                            )}
                          </Typography>
                        )}
                      </Box>
                    </>
                  )}
                </Box>
              ))
            )}
          </Box>
        </>
      )}
      {/* mobile video dialog */}
      <MedicineVideoDialog
        mobileVideoDlg={mobileVideoDlg}
        setMobileVideoDlg={setMobileVideoDlg}
        x={mobileVideoX}
      />
      {/* Delete Medicine Dialog */}
      <Dialog
        open={deleteMedicineDlg}
        onClose={() => {
          setDeleteMedicineDlg(false);
          setDeleteMedicineBuffer("");
        }}
      >
        <DialogContent>
          <DialogContentText>
            {translate7("Are you sure you want to delete this medicine?")}
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button
            onClick={() => {
              setDeleteMedicineDlg(false);
              setDeleteMedicineBuffer("");
            }}
            color="primary"
          >
            Cancel
          </Button>
          <Button onClick={handleConfirmDelete} color="error">
            Confirm
          </Button>
        </DialogActions>
      </Dialog>
      {/* Edit Medicine Dialog */}
      {editMedicineDlg && (
        <EditMedicineDialog
          editMedicineDlg={editMedicineDlg}
          setEditMedicineDlg={setEditMedicineDlg}
          lang={lang}
          langId={langId}
          medListEn={medListEn}
          editMedicineBuffer={editMedicineBuffer}
          setEditMedicineBuffer={setEditMedicineBuffer}
        />
      )}
    </Box>
  );
}
